import { extraArticles } from '@/mocks/articles';

export default function ArticleSection() {
  const allArticles = [
    {
      slug: 'basetao-spreadsheet-guide',
      category: 'Beginner Guide',
      title: 'Basetao Spreadsheet Complete Guide 2026',
      subtitle: 'Everything you need to know about using Basetao Spreadsheet for international shopping. Learn how to discover products, compare prices, and organize your research efficiently.',
      imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20creative%20workspace%20with%20laptop%20displaying%20spreadsheet%20data%20and%20fashion%20lookbook%20magazine%20open%20beside%20it%2C%20color%20swatches%20and%20product%20photos%20scattered%20on%20a%20warm%20oak%20desk%2C%20soft%20morning%20light%20streaming%20through%20sheer%20curtains%2C%20editorial%20productivity%20photography%20with%20warm%20beige%20and%20terracotta%20tones%2C%20elegant%20inspiring%20atmosphere&width=800&height=400&seq=article-card-01-v2&orientation=landscape',
      imageAlt: 'Basetao Spreadsheet Complete Guide 2026',
      link: '/basetao-spreadsheet-guide',
    },
    {
      slug: 'basetao-review',
      category: 'Review',
      title: 'Basetao Review 2026: Is Basetao Legit & Safe?',
      subtitle: 'An honest, in-depth review of Basetao covering platform experience, product selection, warehouse service, shipping, and overall safety for international buyers in 2026.',
      imageUrl: 'https://readdy.ai/api/search-image?query=A%20product%20review%20concept%20with%20magnifying%20glass%20hovering%20over%20fashion%20items%20including%20sneakers%20and%20accessories%20on%20a%20clean%20marble%20surface%2C%20notebook%20with%20handwritten%20notes%20beside%20them%2C%20bright%20natural%20daylight%2C%20editorial%20product%20inspection%20photography%2C%20warm%20grey%20and%20cream%20tones%2C%20professional%20trustworthy%20aesthetic&width=800&height=400&seq=article-card-02-v2&orientation=landscape',
      imageAlt: 'Basetao Review 2026 - Is Basetao Legit and Safe',
      link: '/basetao-review',
    },
    ...extraArticles.map((a) => ({
      slug: a.slug,
      category: a.category,
      title: a.title,
      subtitle: a.subtitle,
      imageUrl: a.imageUrl,
      imageAlt: a.imageAlt,
      link: `/article/${a.slug}`,
    })),
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 mb-4 text-xs font-medium tracking-wider uppercase rounded-full bg-accent-100 text-accent-700">
            Knowledge Hub
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Basetao Spreadsheet Guides &amp; Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Dive into our in-depth articles covering everything you need to know about Basetao Spreadsheet — from beginner tutorials to advanced shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {allArticles.map((article, idx) => (
            <article
              key={idx}
              className="group bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <a href={article.link} className="block relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-label font-medium rounded-full bg-white/90 text-foreground-700 backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </a>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <a href={article.link} className="block">
                  <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                </a>
                <p className="text-foreground-600 text-xs leading-relaxed mb-3 line-clamp-2 flex-1">
                  {article.subtitle}
                </p>
                <a
                  href={article.link}
                  className="whitespace-nowrap inline-flex items-center gap-1.5 text-xs font-label font-semibold text-primary-500 hover:text-primary-600 transition-colors duration-200 cursor-pointer mt-auto"
                >
                  Read Article
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}